import { gql } from '@apollo/client'

/** Row fields for Company Manager Dashboard — appraisal / appraisal-update meeting status table. */
export const companyManagerAppraisalMeetingStatusTableRowFragment = gql`
  fragment CompanyManagerAppraisalMeetingStatusTableRowFields on CompanyManagerAppraisalMeetingStatusTableRowDTO {
    status
    employee {
      id
      firstName
      lastName
      avatarUrl
      currentLevel
    }
    businessUnit {
      id
      name
      displayName
    }
    country
    office {
      id
      name
      code
    }
    buManagers {
      id
      firstName
      lastName
      avatarUrl
    }
    confirmedOrLatestMeetingType
    confirmedOrLatestMeetingId
    confirmedOrLatestMeetingConclusionPdf {
      fileName
      downloadToken
      status
    }
    replyEntryDate
  }
`
